import { initializeApp } from "@firebase/app";
import { getAuth } from "@firebase/auth";

const firebaseConfig = {
  apiKey: `${(window as any)._env_.REACT_APP_FIREBASE_APIKEY}`,
  authDomain: `${(window as any)._env_.REACT_APP_AUTH_DOMAIN}`,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
